<div class="info">
    <!-- <mat-icon>info</mat-icon> -->
    <div class="info-text">
        <div class="file-text">
            <span>Fájl kezelő</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
        <div class="text">
            <!-- <span>Kép beillesztéséhez nyomja meg az alábbi gombot!</span> -->
            <button (click)="openFileManagerPopup()">
                <img src="./assets/images/file-explorer-icon.png" />
            </button>
        </div>
    </div>
</div>
